module.exports = __webpack_public_path__ + "img/bz3.f87b3d2b.jpg";